import React, { useEffect, useState } from "react";
import { useLocaleContext } from '../../context/LocaleContext';
import { useParams } from "react-router-dom";
import PageContainer from '../../components/PageContainer';
import MembersPageFilters from '../../components/Members/MembersComponents/MembersPageFilters';
import MembersPageView from '../../components/Members/MembersViews/MembersPageView';
import { ModalContextProvider } from '../../context/ModalContext';

import './style.scss';
import { capitalizer } from "../../../../cp/utils";

export default ({ event, page, children }) => {
    const $locale = useLocaleContext();
    const [members, setMembers] = useState(null);
    const params = useParams();

    useEffect(() => {
        setMembers(event.members);
    }, [event]);

    useEffect(() => {
        addPageStyles();
    }, [params]);

    function addPageStyles() {
        const memberPage = document.querySelector('.members-page-root');

        memberPage.style.backgroundImage = `url(${page.settings.backgroundUrl})`;

        page?.settings?.backgroundFixed
            ? memberPage.classList.add('members-page-root--background-fixed')
            : memberPage.classList.remove('members-page-root--background-fixed')
    }

    return (
        <PageContainer>
            <section className={`${!!page.settings.backgroundUrl ? 'page-section-background' : ''} members-page ${page?.settings?.showSubstrate ? 'page-section-background--filled' : ''}`}>
                <div className="members-page-header">
                    {page.settings.showTitle && (
                        <h1>
                            {page.settings ? page.settings[`title${capitalizer($locale.name)}`] : $locale.getProperty(page, 'title')}
                        </h1>
                    )}
                </div>
                <div className="members-page-filters">
                    <MembersPageFilters
                        event={event}
                        onFilter={setMembers}
                        hasOrganizationFilter={page?.settings?.showOrganizationFilter}
                    />
                </div>
                <div className="members-page-list">
                    <ModalContextProvider>
                        <MembersPageView
                            event={event}
                            members={members}
                            showBigPhotos={page?.settings?.showBigPhotos}
                            showPhotoCentered={page?.settings?.showPhotoCentered}
                        />
                    </ModalContextProvider>
                </div>
            </section>
            {children}
        </PageContainer>
    )
}
